<template>
  <div>
    <p class="text-center mt-20">
      <b>{{ title }}</b>
    </p>
    <div class="box mt-20">
      <div class="box-body">
        <textarea class="form-control" rows="8" v-model="localValue"></textarea>
      </div>
    </div>
    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close" @click="cancel">
        <i class="icon-close mr-5"></i>취소</button>
      <button class="btn btn-lg success" data-dismiss="modal" aria-label="Close" @click="apply">
        <i class="icon-check mr-5"></i>적용</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => '설명'
    },
    value: {
      type: String,
      default: () => ''
    },
    onConfirm: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  methods: {
    apply() {
      if (this.onConfirm) {
        this.onConfirm(this.localValue);
      }
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>
